/*
 * @Author: chengjia 645680217@qq.com
 * @Date: 2022-10-11 13:43:43
 * @LastEditors: chengjia 645680217@qq.com
 * @LastEditTime: 2022-10-31 18:55:08
 * @FilePath: \xm-runing-main\src\store\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { App } from 'vue';
import { createPinia } from 'pinia';
// 持久化插件
import piniaPluginPersist from 'pinia-plugin-persist'
const store = createPinia();
store.use(piniaPluginPersist)
export function setupStore(app: App<Element>) {
  app.use(store);
}

export { store };
